var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5H21.3333",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9H18.3333",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 15H21.3333",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 19H18.3333",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 5C3.33331 4.73478 3.43867 4.48043 3.62621 4.29289C3.81374 4.10536 4.0681 4 4.33331 4H8.33331C8.59853 4 8.85288 4.10536 9.04042 4.29289C9.22796 4.48043 9.33331 4.73478 9.33331 5V9C9.33331 9.26522 9.22796 9.51957 9.04042 9.70711C8.85288 9.89464 8.59853 10 8.33331 10H4.33331C4.0681 10 3.81374 9.89464 3.62621 9.70711C3.43867 9.51957 3.33331 9.26522 3.33331 9V5Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 15C3.33331 14.7348 3.43867 14.4804 3.62621 14.2929C3.81374 14.1054 4.0681 14 4.33331 14H8.33331C8.59853 14 8.85288 14.1054 9.04042 14.2929C9.22796 14.4804 9.33331 14.7348 9.33331 15V19C9.33331 19.2652 9.22796 19.5196 9.04042 19.7071C8.85288 19.8946 8.59853 20 8.33331 20H4.33331C4.0681 20 3.81374 19.8946 3.62621 19.7071C3.43867 19.5196 3.33331 19.2652 3.33331 19V15Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.0899712e76e096a33fa03a7c95d43379.svg";
export { ForwardRef as ReactComponent };